import React from 'react';
import cx from 'classnames';
import * as styles from './DescriptionPlaceholder.scss';

const DescriptionPlaceholder = ({ className, isMobile } = {}) => (
  <div className={cx(styles.descriptionPlaceholder, styles[className], { [styles.mobile]: isMobile })}>
    <div className={cx(styles.descriptionColumn, styles.titleColumn)}>
      <p className={styles.placeholderTitle} />
    </div>

    <div className={styles.descriptionColumn}>
      <p className={styles.placeholderRow} />
      <p className={styles.placeholderRow} />
      <p className={styles.placeholderRow} />
    </div>

    <div className={styles.descriptionColumn}>
      <p className={styles.placeholderRow} />
      <p className={styles.placeholderRow} />
      <p className={styles.placeholderRow} />
    </div>
  </div>
);

export default DescriptionPlaceholder;
